/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate } from 'react-router-dom'

import { URL_RENOVADOR } from 'config'
import { UserContext } from 'contexts/user'
import { useSelectedCreditTabStore } from 'store'

// Components
import PageWrapper from 'components/PageWrapper'
import OngoingAdvance from 'pages/advances/components/OngoingAdvance'

import PrimaryButton from 'components/primaryButton'
import CreditTabs from './components/CreditTabs'

// wayni-credito

const WayniCredit = () => {
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const { selectedTab } = useSelectedCreditTabStore()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_wayni_credito' })
  }, [])

  return (
    <PageWrapper title='Wayni Crédito'>
      <section className='flex flex-col text-black items-center sm:max-w-md pb-6 mx-auto h-full'>
        <OngoingAdvance className='mb-8' />

        <CreditTabs />

        <PrimaryButton
          className='fixed shadow-navMob bottom-20 !w-[90vw] md:max-w-md md:static md:shadow-none md:mt-2'
          buttonText={
            selectedTab === 0 ? 'Simular adelanto' : 'Simular préstamo'
          }
          primaryButtonFunction={() => {
            if (selectedTab === 0) {
              trackEvent({ eventName: 'bille_boton_simular_adelanto' })
              navigate('/adelantos/tipo-de-adelanto')
            } else {
              trackEvent({ eventName: 'bille_boton_simular_prestamo' })
              window
                .open(
                  `${URL_RENOVADOR}iniciando?access_token=${user.access_token}`,
                  '_blank'
                )
                .focus()
            }
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default WayniCredit
